import { render } from "./AboutAuDetail.vue?vue&type=template&id=aaea7a58&scoped=true"
import script from "./AboutAuDetail.vue?vue&type=script&lang=js"
export * from "./AboutAuDetail.vue?vue&type=script&lang=js"

import "./AboutAuDetail.vue?vue&type=style&index=0&id=aaea7a58&scoped=true&lang=css"

import exportComponent from "/Users/apple/Projects/opm/yuzhangmen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaea7a58"]])

export default __exports__